import { Box, useTheme } from "@mui/material";
import { Link, useLocation } from "react-router-dom";

import { useAuth } from "@/providers";
import { PageLayout, RobotoDivider } from "@/shared/components";
import {
  RobotoStyledTab,
  RobotoStyledTabs,
} from "@/shared/components/RobotoStyledTabs";
import { OrganizationTier } from "@/shared/domain/orgs/OrgRecord";

import { SettingsTabRoutes } from "./SettingsTabRoutes";
import {
  useActiveSettingsTab,
  SettingsTab,
} from "./useActiveSettingsTabFromUrl";

export function Settings() {
  const theme = useTheme();
  const location = useLocation();

  const { currentOrganization } = useAuth();
  const isPremiumOrg = currentOrganization?.tier === OrganizationTier.Premium;

  const [activeTab, setActiveTab] = useActiveSettingsTab();

  return (
    <PageLayout title={"Roboto - Settings"} headerContentLeft={"Settings"}>
      <div>
        <RobotoStyledTabs
          value={activeTab}
          onChange={(_event, nextTab: SettingsTab) => {
            setActiveTab(nextTab);
          }}
          aria-label="settings tabs"
        >
          <RobotoStyledTab
            value={SettingsTab.Organization}
            data-cy="organization"
            label="Organization"
            component={Link}
            to={{
              pathname: SettingsTab.Organization,
              search: location.search,
            }}
            replace
          />
          <RobotoStyledTab
            value={SettingsTab.Tokens}
            label="Tokens"
            component={Link}
            to={{
              pathname: SettingsTab.Tokens,
              search: location.search,
            }}
            replace
          />
          <RobotoStyledTab
            value={SettingsTab.Usage}
            label="Usage"
            component={Link}
            to={{
              pathname: SettingsTab.Usage,
              search: location.search,
            }}
            replace
          />
          <RobotoStyledTab
            value={SettingsTab.AI}
            label="AI"
            component={Link}
            to={{
              pathname: SettingsTab.AI,
              search: location.search,
            }}
            replace
          />
          <RobotoStyledTab
            value={SettingsTab.Secrets}
            label="Secrets"
            component={Link}
            to={{
              pathname: SettingsTab.Secrets,
              search: location.search,
            }}
            replace
          />
          {isPremiumOrg && (
            <RobotoStyledTab
              value={SettingsTab.Integrations}
              label="Integrations"
              component={Link}
              to={{
                pathname: SettingsTab.Integrations,
                search: location.search,
              }}
              replace
            />
          )}
        </RobotoStyledTabs>

        <RobotoDivider />
      </div>

      <Box
        sx={{
          marginTop: theme.spacing(3),
        }}
      >
        <SettingsTabRoutes />
      </Box>
    </PageLayout>
  );
}
